import React, { Component, Fragment } from "react";
import "./sizing.css";
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";

import {
    getequpmentCategories,
    getCompressorCategories,
    getCompressorTypes
} from "../../constants/sizing-constant";

import { getproductsBySizingParameters, getScrew } from "../../constants/products-constant";

import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import ProductSuggestions from './ProductSuggestions';
import CompressorSizing from "./CompressorSizing";
import TankSizing from "./tankSizing";
import DryerSizing from "./dryerSizing";
import O2Sizing from "./O2Sizing";
import N2Sizing from "./N2Sizing";
import CoalTowerSizing from "./CoalTowerSizing";
import FilterSizing from "./FilterSizing";
import WaterTrapSizing from "./WaterTrapSizing";

import ProductSuggestionsDesktop from "./ProductSuggestionsDesktop";
import ProductSuggestionsMobile from "./ProductSuggestionsMobile";

export default class sizing extends Component {

    constructor(props) {
        super(props)

        this.setSize = this.setSize.bind(this);
    }

    setSize() {
        this.setState({
            width: window.innerWidth
        });
    }

    state = {
        width: 0,

        showProductSection: "false",
        products: [],
        productsCount: 0,

        equipmentCategories: [],
        isEquipmentCategoriesSelected: "false",
        selectedEqipment: "null",

        compressorCategories: [],
        isCompressorCategoriesSelected: "false",
        selectedCompressorType: "null",
    };

    componentDidMount() {
        this.setSize();
        window.addEventListener('resize', this.setSize);

        const products = [...getproductsBySizingParameters("", "", "")]

        const productsCount = products.length;

        const equipmentCategories = [...getequpmentCategories()];

        const compressorCategories = [...getCompressorCategories()];

        this.setState({
            products,
            productsCount,
            equipmentCategories,
            compressorCategories
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setSize);
    }

    handleEquipmentCategorieselect = equipment => {
        const productsCount = 0;

        if (equipment) {
            if (equipment.value === "1") {
                const productList = [...getproductsBySizingParameters("کمپرسور", "", "")];
                const productListCount = productList.length;
                this.setState({
                    products: productList,
                    productsCount: productListCount,
                    isEquipmentCategoriesSelected: "true",
                    selectedEqipment: equipment.value,
                    showProductSection: "true"
                });
            }
            else if (equipment.value === "2") {
                const productList = [...getproductsBySizingParameters("مخزن هوای فشرده", "", "")];
                const productListCount = productList.length;
                this.setState({
                    products: productList,
                    isEquipmentCategoriesSelected: "true",
                    selectedEqipment: equipment.value,
                    productsCount: productListCount,
                    showProductSection: "true"
                });
            }
            else if (equipment.value === "3") {
                const productList = [...getproductsBySizingParameters("درایر", "", "")];
                const productListCount = productList.length;
                this.setState({
                    products: productList,
                    isEquipmentCategoriesSelected: "true",
                    selectedEqipment: equipment.value,
                    productsCount: productListCount,
                    showProductSection: "true"
                });
            }
            else if (equipment.value === "4") {
                const productList = [...getproductsBySizingParameters("اکسیژن ساز", "", "")];
                const productListCount = productList.length;
                this.setState({
                    products: productList,
                    isEquipmentCategoriesSelected: "true",
                    selectedEqipment: equipment.value,
                    productsCount: productListCount,
                    showProductSection: "true"
                });
            }
            else if (equipment.value === "5") {
                const productList = [...getproductsBySizingParameters("نیتروژن ساز", "", "")];
                const productListCount = productList.length;
                this.setState({
                    products: productList,
                    isEquipmentCategoriesSelected: "true",
                    selectedEqipment: equipment.value,
                    productsCount: productListCount,
                    showProductSection: "true"
                });
            }
            else if (equipment.value === "6") {
                const productList = [...getproductsBySizingParameters("برج ذغال", "", "")];
                const productListCount = productList.length;
                this.setState({
                    products: productList,
                    isEquipmentCategoriesSelected: "true",
                    selectedEqipment: equipment.value,
                    productsCount: productListCount,
                    showProductSection: "true"
                });
            }
            else if (equipment.value === "7") {
                const productList = [...getproductsBySizingParameters("فیلتر", "", "")];
                const productListCount = productList.length;
                this.setState({
                    products: productList,
                    isEquipmentCategoriesSelected: "true",
                    selectedEqipment: equipment.value,
                    productsCount: productListCount,
                    showProductSection: "true"
                });
            }
            else if (equipment.value === "8") {
                const productList = [...getproductsBySizingParameters("تله آبگیر", "", "")];
                const productListCount = productList.length;
                this.setState({
                    products: productList,
                    isEquipmentCategoriesSelected: "true",
                    selectedEqipment: equipment.value,
                    productsCount: productListCount,
                    showProductSection: "true"
                });
            }
        }
        else {
            this.setState({
                productsCount,
                products: [],
                showProductSection: "false"
            });
        }
    };

    handleCompressorSelect = compressor => {
        if (compressor) {
            if (compressor.value === "1") {
                const productList = [...getScrew("", "")];
                const productListCount = productList.length;
                this.setState({
                    products: productList,
                    isCompressorCategoriesSelected: "true",
                    selectedCompressorType: compressor.value,
                    productsCount: productListCount,
                });
            }
            else {
                const suggestedProducts = [...getproductsBySizingParameters("کمپرسور", compressor.value, "")];
                const productsCount = suggestedProducts.length;

                this.setState({
                    isCompressorCategoriesSelected: "true",
                    selectedCompressorType: compressor.value,
                    products: suggestedProducts,
                    productsCount
                });
            }
        }
    };

    productHandler = (newProductList) => {
        this.setState({
            products: newProductList
        })
    }

    render() {
        let productSuggestionsContent = this.state.width < 600 ? <ProductSuggestionsMobile products={this.state.products} /> : <ProductSuggestionsDesktop products={this.state.products} />;
        return (
            <Page>
                <Header />
                <section className="container sizing">
                    <div className="container">
                        <div className="row sizing hrow">
                            <h1 className="text-title-body">سایزینگ و انتخاب تجهیزات</h1>
                            <p className="text-body gray-box small">
                                برای انتخاب تجهیزات مناسب مورد نیاز خود ، لطفا فیلد های زیر را تکمیل نمایید .
                            </p>
                            <DropDownWhiteStyle
                                items={this.state.equipmentCategories}
                                placeholder="نوع تجهیز"
                                onItemSelect={this.handleEquipmentCategorieselect}
                            />
                            {this.state.isEquipmentCategoriesSelected === "true" &&
                                <Fragment>
                                    {this.state.selectedEqipment === "1" &&
                                        <CompressorSizing handler={this.productHandler} />
                                    }
                                    {this.state.selectedEqipment === "2" &&
                                        < TankSizing handler={this.productHandler} />
                                    }
                                    {this.state.selectedEqipment === "3" &&
                                        < DryerSizing handler={this.productHandler} />
                                    }
                                    {this.state.selectedEqipment === "4" &&
                                        < O2Sizing handler={this.productHandler} />
                                    }
                                    {this.state.selectedEqipment === "5" &&
                                        < N2Sizing handler={this.productHandler} />
                                    }
                                    {this.state.selectedEqipment === "6" &&
                                        < CoalTowerSizing handler={this.productHandler} />
                                    }
                                    {this.state.selectedEqipment === "7" &&
                                        < FilterSizing handler={this.productHandler} />
                                    }
                                    {this.state.selectedEqipment === "8" &&
                                        < WaterTrapSizing handler={this.productHandler} />
                                    }
                                </Fragment>
                            }
                        </div>
                    </div>
                </section>
                {productSuggestionsContent}
                <Footer />
            </Page>
        );
    }
}
